var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.8335,
    cy: 33.0191,
    r: 28.7222,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.8335,
    cy: 33.0191,
    r: 25.2222,
    stroke: "#1F1414",
    strokeWidth: 7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.0562,
    cy: 29.355,
    r: 28.7222,
    fill: "#084254"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.0562,
    cy: 29.355,
    r: 25.2222,
    stroke: "black",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 47.8018C14.8647 47.8018 21.4561 34.1527 21.4561 27.4675C21.4561 40.838 33.3889 47.8018 42.1964 47.8018C27.6498 47.8018 21.4561 60.0582 21.4561 67.8576C21.4561 54.4871 8.67105 47.8018 1 47.8018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7758 27.552C49.1903 27.552 53.1906 19.2684 53.1906 15.2111C53.1906 23.3257 60.4325 27.552 65.7778 27.552C56.9495 27.552 53.1906 34.9903 53.1906 39.7238C53.1906 31.6093 45.4314 27.552 40.7758 27.552Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4561 15.5415C26.6196 15.5415 29.0743 10.4584 29.0743 7.96875C29.0743 12.9481 33.5182 15.5415 36.7982 15.5415C31.3809 15.5415 29.0743 20.106 29.0743 23.0106C29.0743 18.0312 24.3129 15.5415 21.4561 15.5415Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 47.8018C14.8647 47.8018 21.4561 34.1527 21.4561 27.4675C21.4561 40.838 33.3889 47.8018 42.1964 47.8018C27.6498 47.8018 21.4561 60.0582 21.4561 67.8576C21.4561 54.4871 8.67105 47.8018 1 47.8018Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7758 27.552C49.1903 27.552 53.1906 19.2684 53.1906 15.2111C53.1906 23.3257 60.4325 27.552 65.7778 27.552C56.9495 27.552 53.1906 34.9903 53.1906 39.7238C53.1906 31.6093 45.4314 27.552 40.7758 27.552Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4561 15.5415C26.6196 15.5415 29.0743 10.4584 29.0743 7.96875C29.0743 12.9481 33.5182 15.5415 36.7982 15.5415C31.3809 15.5415 29.0743 20.106 29.0743 23.0106C29.0743 18.0312 24.3129 15.5415 21.4561 15.5415Z",
    stroke: "#0063CD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 46.5753C16.0874 46.5753 22.6788 32.9262 22.6788 26.2409C22.6788 39.6114 34.6115 46.5753 43.4191 46.5753C28.8725 46.5753 22.6788 58.8316 22.6788 66.6311C22.6788 53.2605 9.89371 46.5753 2.22266 46.5753Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9985 26.3254C50.4129 26.3254 54.4132 18.0418 54.4132 13.9846C54.4132 22.0991 61.6552 26.3254 67.0004 26.3254C58.1722 26.3254 54.4132 33.7637 54.4132 38.4972C54.4132 30.3827 46.654 26.3254 41.9985 26.3254Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6788 14.315C27.8422 14.315 30.2969 9.23187 30.2969 6.74219C30.2969 11.7216 34.7409 14.315 38.0209 14.315C32.6035 14.315 30.2969 18.8794 30.2969 21.784C30.2969 16.8047 25.5356 14.315 22.6788 14.315Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22266 46.5753C16.0874 46.5753 22.6788 32.9262 22.6788 26.2409C22.6788 39.6114 34.6115 46.5753 43.4191 46.5753C28.8725 46.5753 22.6788 58.8316 22.6788 66.6311C22.6788 53.2605 9.89371 46.5753 2.22266 46.5753Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9985 26.3254C50.4129 26.3254 54.4132 18.0418 54.4132 13.9846C54.4132 22.0991 61.6552 26.3254 67.0004 26.3254C58.1722 26.3254 54.4132 33.7637 54.4132 38.4972C54.4132 30.3827 46.654 26.3254 41.9985 26.3254Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6788 14.315C27.8422 14.315 30.2969 9.23187 30.2969 6.74219C30.2969 11.7216 34.7409 14.315 38.0209 14.315C32.6035 14.315 30.2969 18.8794 30.2969 21.784C30.2969 16.8047 25.5356 14.315 22.6788 14.315Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotIcon);
export default __webpack_public_path__ + "static/media/chatbotIcon.132f151c89a53f304d79bd778c6df10a.svg";
export { ForwardRef as ReactComponent };